// components/GeneratePdfModal.tsx
import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody,
  ModalFooter, ModalCloseButton, Button, Text, useToast
} from '@chakra-ui/react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  currentRoom?: { luogo: string; data: string; titoloEvento?: string };
}

export const GeneratePdfModal: React.FC<Props> = ({ isOpen, onClose, currentRoom }) => {
  const toast = useToast();

  const handleGenerate = async () => {
    if (!currentRoom) {
      toast({
        title: "Errore",
        description: "Nessuna sala selezionata.",
        status: "error",
        duration: 3000,
        isClosable: true
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const url = `${process.env.REACT_APP_API_URL}/generate-pdf?date=${currentRoom.data}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!res.ok) throw new Error("Errore nella generazione del PDF");

      const blob = await res.blob();
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);

      onClose();
      toast({
        title: "PDF generato",
        description: "Il PDF è stato generato e aperto.",
        status: "success",
        duration: 4000,
        isClosable: true
      });

    } catch (err) {
      console.error("Errore generazione PDF:", err);
      toast({
        title: "Errore",
        description: "Impossibile generare il PDF.",
        status: "error",
        duration: 4000,
        isClosable: true
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Genera PDF Prenotati</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {currentRoom ? (
            <>
              <Text mb={2}>Vuoi generare il PDF per questa sala?</Text>
              <Text fontWeight="bold" mt={4}>Evento: {currentRoom.titoloEvento || 'N/A'}</Text>
              <Text>Luogo: {currentRoom.luogo}</Text>
              <Text>Data: {new Date(currentRoom.data).toLocaleDateString('it-IT')}</Text>
            </>
          ) : (
            <Text>Nessuna sala selezionata</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleGenerate} isDisabled={!currentRoom}>
            Genera PDF
          </Button>
          <Button variant="ghost" onClick={onClose}>Annulla</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};